import { render, staticRenderFns } from "./EntityContacts.vue?vue&type=template&id=703f7543"
import script from "./EntityContacts.vue?vue&type=script&lang=js"
export * from "./EntityContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports